import PlayBackButton, { PlayBackButtonProps } from './PlayBackButton';

export default PlayBackButton;
export type { PlayBackButtonProps };
